<template>
  <main class="page-consultants-index">
    <div class="container">
      <BModal title="Profilo" dialog-class="modal--type-dialog" id="consultant-modal" ref="consultant-modal" hide-footer centered scrollable>
        <ConsultantForm :user="consultant" @closeModal="$refs['consultant-modal'].hide()" @update="successForm()"/>
      </BModal>

      <PageTitle class="mb-5">Supervisors</PageTitle>
      <div class="row">
        <div class="col-lg-4 col-md-6 pb-4" v-for="(consultant, index) in consultants" :key="index">
          <LawaCard :name="consultant.name + ' ' + consultant.surname" class="h-100">
            <template #header>
              <p class="text-uppercase text-right mb-0">
                <span class="d-block small font-weight-light text-muted">Stato</span>
                <span :class="consultant.signed ? (consultant.disabled ? 'text-danger' : 'text-success') : 'text-warning'">
                  {{ consultant.signed ? (consultant.disabled ? 'Disattivo' : 'Attivo') : 'Invito inviato' }}
                </span>
              </p>
            </template>
            <div style="min-height: 105px;">
              <h4 class="font-weight-bold truncated-text pointer">
                {{ consultant.signed ? consultant.name + ' ' + consultant.surname : 'In attesa di conferma' }}
              </h4>
              <p class="small text-uppercase mb-1">
                <strong>Email:</strong>
                {{ consultant.email || 'email@prova.it' }}
              </p>
              <p v-if="consultant.signed" class="small text-uppercase mb-1">
                <strong>Numero di aziende gestite:</strong> {{ consultant.nbCompanies || 0 }}
              </p>
              <p v-if="consultant.signed" class="small text-uppercase mb-1">
                <strong>Aziende ancora attivabili:</strong> {{ consultant | maxCompaniesAllowed }}
              </p>
            </div>
            <template #footer>
              <AwlConfirm
                v-if="!consultant.signed"
                class="btn btn-block text-left"
                status='outline-danger btn'
                title='Elimina invito'
                @confirm="deleteReservation(consultant)"
              >
                Sei sicuro di voler eliminare l'invito per l'utente {{ consultant.name }} {{ consultant.surname }} per questa azienda?
              </AwlConfirm>
              <AwlConfirm
               v-if="consultant.signed"
                :status="!consultant.disabled ? 'outline-danger btn' : 'outline-primary btn'"
                :title="!consultant.disabled ? 'Disattiva' : 'Attiva'"
                @confirm="onConfirm($event, consultant)"
              >
                Sei sicuro di voler {{!consultant.disabled ? 'disattivare' : 'attivare'}} il supervisor {{consultant.fullName}}?
              </AwlConfirm>
              <button class="btn btn-primary align-self-center m-0" :class="consultant.signed ? '' : 'btn-block'" @click="!consultant.signed ? resendEmail(consultant) : openEditConsultantModal(consultant)">
                  <i class="fas fa-share mr-1" v-if="!consultant.signed"></i>
                  {{!consultant.signed ? 'Rimanda invito' : 'Modifica'}}
              </button>
            </template>
          </LawaCard>
        </div>
      </div>

      <div class="fab-container">
        <AwlFabAddButton class="ml-auto" @click="$refs['invite-company-modal'].show()" />
      </div>

      <BModal title="Invita" dialog-class="modal--type-dialog" id="invite-company-modal" ref="invite-company-modal" hide-footer centered scrollable>
        <p>
          Invita un consulente
          <br />
          Deve accettare il tuo invito per poter accedere alla piattaforma
        </p>
        <ReservationForm @success="successForm" role="consultant" />
      </BModal>
    </div>
  </main>
</template>

<script>

import $api from '../../../../libs/Api/services/api';
import { BModal } from 'bootstrap-vue';

export default {
  components: {
    BModal,
    ConsultantForm: () => import('../../../components/Account/ConsultantForm'),
    AwlConfirm: () => import('../../../../libs/Modals/components/AwlConfirm'),
    AwlFabAddButton: () => import('../../../components/Ui/AwlFabAddButton'),
    ReservationForm: () => import('../../../components/Account/ReservationForm'),
    PageTitle: () => import('../../../components/Layout/LayoutOperative/PageTitle'),
    LawaCard: () => import('../../../components/Layout/Card/LawaCard'),
  },
  filters: {
    maxCompaniesAllowed (consultant) {
      if (!consultant) {
        return '';
      }

      if (consultant.maxCompaniesAllowed === null) {
        return 'illimitate';
      }

      const remainings = consultant.maxCompaniesAllowed - consultant.nbCompanies;

      return remainings < 0 ? '0' : remainings;
    },
  },
  data () {
    return {
      consultants: [],
      consultant: null,
    };
  },
  computed: {
    consultantsTable () {
      const heading = [
        { key: 'name', label: 'Supervisor' },
        { key: 'nbCompanies', label: 'Numero di Aziende' },
      ];

      return {
        heading,
        rows: this.consultants,
      };
    },
  },
  methods: {
    openEditConsultantModal (consultant) {
      this.consultant = consultant;
      this.$refs['consultant-modal'].show();
    },
    deleteReservation (consultant) {
      this.$api.deleteUserReservation(consultant.reservationId)
        .then(() => {
          this.makeToast('success', 'Invito eliminato', 'Invito correttamente eliminato');
        })
        .catch(err => {
          this.$log.error(err);
          this.makeToast('danger', 'Errore imprevisto', 'Errore nell\'eliminazione dell\'invito');
        }).finally(() => {
          this.$api.consultants(true)
            .then(res => {
              this.consultants = res.data?.consultants || [];
            }).catch(err => {
              this.$log.error(err);
              this.makeToast('danger', 'Errore imprevisto', 'Errore nello scaricamento dei dati utente');
            });
        });
    },
    resendEmail (consultant) {
      this.$api.reserveUser({ ...consultant, role: 'consultant' })
        .then(() => {
          this.makeToast('success', 'Invito inviato', `Email correttamente inviata a ${consultant.email}`);
        }).catch(err => {
          this.$log.error(err);
        }).finally(() => {
          this.$api.consultants(true)
            .then(res => {
              this.consultants = res.data?.consultants || [];
            }).catch(err => {
              this.$log.error(err);
            });
        });
    },
    makeToast (variant = null, title = '', content = 'Successo') {
      this.$bvToast.toast(content, {
        title: title,
        toaster: 'b-toaster-top-right',
        solid: true,
        variant: variant,
        appendToast: true,
      });
    },
    async onConfirm (event, consultant) {
      try {
        if (consultant.disabled) {
          await this.$api.enableConsultant(consultant.id);
        } else {
          await this.$api.disableConsultant(consultant.id);
        }

        this.consultants = (await this.$api.consultants(true)).data?.consultants || [];
      } catch (err) {
        this.$log.error(err);
      }
    },
    async successForm () {
      this.$refs['invite-company-modal'].hide();

      try {
        const res = await this.$api.consultants(true);
        this.consultants = res.data?.consultants || [];
      } catch (error) {
        this.$log.error(error);
      }
    },
  },
  async beforeRouteEnter (to, from, next) {
    try {
      const res = await $api.consultants(true);
      return next(vm => {
        vm.consultants = res.data?.consultants || [];
      });
    } catch (error) {
      return next(vm => vm.$log.error(error));
    }
  },
};

</script>

<style lang="scss">

.page-consultants-index {
  .awl-card {
    .awl-card--content {
      padding-left: 0;
      padding-right: 0;
    }
  }
  .pointer {
    cursor: pointer;
  }
}

</style>
